import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GetStudentsIndividualWorkloadReportUseCaseInterface } from 'domain/usecases';

interface IStudentsIndividualWorkloadReportState {
  studentsCHI: GetStudentsIndividualWorkloadReportUseCaseInterface.Result;
}

interface IPayloadStudentsIndividualWorkloadReport
  extends PayloadAction<GetStudentsIndividualWorkloadReportUseCaseInterface.Result> {}

const initialState: IStudentsIndividualWorkloadReportState = {
  studentsCHI: [],
};

export const StudentsIndividualWorkloadReportSlice = createSlice({
  name: 'students-indivual-workload',
  initialState,
  reducers: {
    saveStudentsCHI: (
      state,
      action: IPayloadStudentsIndividualWorkloadReport,
    ) => {
      state.studentsCHI = action.payload;
    },
    clearStudentsCHI: (state) => {
      state.studentsCHI = [];
    },
  },
});

export const { saveStudentsCHI, clearStudentsCHI } =
  StudentsIndividualWorkloadReportSlice.actions;

export default StudentsIndividualWorkloadReportSlice.reducer;
